// src/pages/healthcare/consultation/consultationComponents/ConsultDrawerShell.tsx
import React, { ReactNode } from "react";
import { Alert, Button, Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import { CAPTURE_STOPPED_ACTION, CAPTURE_STOPPED_MESSAGE, CaptureState } from "../../../../hooks/consult/useConsultTranscripts";

interface ConsultDrawerShellProps {
	title: ReactNode;
	open: boolean;
	onClose: () => void;
	captureState: CaptureState | null;
	onResumeCapture: () => void;
	left: ReactNode;
	rightTop?: ReactNode;
	right: ReactNode;
}

const ConsultDrawerShell: React.FC<ConsultDrawerShellProps> = ({ title, open, onClose, captureState, onResumeCapture, left, rightTop, right }) => {
	return (
		<Drawer
			title={title}
			open={open}
			onClose={onClose}
			width="100vw"
			data-testid="consultation-drawer"
			styles={{
				body: { padding: 0, display: "flex", flexDirection: "column", height: "100%" },
				header: { padding: "8px 16px", background: "var(--primary-color)", borderBottom: "1px solid var(--border-color)" },
			}}
			closeIcon={<CloseOutlined />}
		>
			{/* Above the columns, so it is seen without opening the transcripts panel — and it never auto-clears. */}
			{captureState === "stopped" && (
				<Alert
					type="warning"
					showIcon
					banner
					style={{ flexShrink: 0 }}
					data-testid="consultation-capture-warning"
					message={CAPTURE_STOPPED_MESSAGE}
					action={
						<Button size="small" type="primary" onClick={onResumeCapture} data-testid="consultation-capture-resume-btn">
							{CAPTURE_STOPPED_ACTION}
						</Button>
					}
				/>
			)}
			{/* minHeight: 0 stops the banner from clipping the columns below it. */}
			<div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
				<div
					style={{
						flex: 2,
						height: "100%",
						overflow: "hidden",
						display: "flex",
						flexDirection: "column",
						borderRight: "1px solid var(--border-color)",
					}}
				>
					{left}
				</div>
				<div
					style={{
						flex: 1,
						height: "100%",
						overflow: "hidden",
						background: "var(--background-color)",
						display: "flex",
						flexDirection: "column",
					}}
				>
					{rightTop}
					{right}
				</div>
			</div>
		</Drawer>
	);
};

export default ConsultDrawerShell;
